import { Temporal } from '@js-temporal/polyfill';

import type { BookableNight, BookableNights, DayOfWeek } from './types';

type PlainDate = Temporal.PlainDate;

// Temporal numbers days Monday = 1 ... Sunday = 7.
const DAYS: DayOfWeek[] = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

export const toPlainDate = (date: string): PlainDate =>
	Temporal.PlainDate.from(date);

export const maxDate = (a: PlainDate, b: PlainDate) =>
	Temporal.PlainDate.compare(a, b) >= 0 ? a : b;

export const minDate = (a: PlainDate, b: PlainDate) =>
	Temporal.PlainDate.compare(a, b) <= 0 ? a : b;

/** Every date from `start` to `end`, both inclusive. Empty when `end` is before `start`. */
export const getDatesInRange = (
	start: PlainDate,
	end: PlainDate,
): PlainDate[] => {
	const dates: PlainDate[] = [];
	for (
		let current = start;
		Temporal.PlainDate.compare(current, end) <= 0;
		current = current.add({ days: 1 })
	) {
		dates.push(current);
	}
	return dates;
};

export const getDayOfWeek = (date: PlainDate): DayOfWeek =>
	DAYS[date.dayOfWeek - 1];

export const formatDate = (date: PlainDate): string => date.toString();

export const getPriceInXDays = (
	currentDate: PlainDate,
	days: number,
	nightlyPrices: BookableNights,
): BookableNight | undefined =>
	nightlyPrices[formatDate(currentDate.add({ days }))];

export const arrayOrEmptyIfAllZeroes = (los: number[]) =>
	los.some((n) => n !== 0) ? los : [];
